import { setContext } from '@apollo/client/link/context';
import { ApolloLink, createHttpLink } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'js-sha256';
// import { sha256 } from 'crypto-hash';
require('cross-fetch/polyfill');

const POST_FALLBACK_VARIABLES_LIMIT = 2000;

function getLink(options = {}) {
  const {
    uri = process.env.BLAZE_GRAPHQL_URI,
    middleware = [],
    linkOptions = {},
    disableUpload = false,
    enablePersistedQueries = true,
    disablePostFallback = process.env.BLAZE_GRAPHQL_POST_FALLBACK_DISABLED === 'true',
    postFallbackVariablesLimit = POST_FALLBACK_VARIABLES_LIMIT
  } = options;
  const link = disableUpload
    ? createHttpLink({ uri, ...linkOptions })
    : createUploadLink({ uri, ...linkOptions });

  const preparedMiddleware = middleware.map(middlewareItem => {
    if (typeof middlewareItem === 'function') {
      return setContext(middlewareItem);
    }

    return middlewareItem;
  });

  if (disableUpload && enablePersistedQueries) {
    const persistedQueryLink = createPersistedQueryLink({
      useGETForHashedQueries: true,
      sha256
      // sha256: query => sha256().update(query).digest('hex')
    });

    // Hashed queries are sent as GETs with variables serialised into the URL;
    // oversized variables overflow proxy request-line limits (nginx replies
    // 414). Operations over the limit skip the persisted-query link and fall
    // through to the terminating link, which sends them as POSTs.
    const fitsInGetUrl = operation =>
      JSON.stringify(operation.variables || {}).length <= postFallbackVariablesLimit;

    preparedMiddleware.push(
      disablePostFallback ? persistedQueryLink : ApolloLink.split(fitsInGetUrl, persistedQueryLink)
    );
  }

  return new ApolloLink.from([...preparedMiddleware, link]); // eslint-disable-line
}

export default getLink;
